import { ApprovalI } from "../approvals/approvalsTypes";

export const approvalDetailsTypes = {
  SET_APPROVAL: "@APPROVAL_DETAILS/SET_APPROVAL",
};

export interface ApprovalDetailsStateI {
  approval?: ApprovalI;
  index?: number;
  detailsType?: ApprovalDetailsType;
}

export interface SetApprovalI {
  type: typeof approvalDetailsTypes.SET_APPROVAL;
  payload?: ApprovalI;
  index?: number;
  detailsType?: ApprovalDetailsType;
}

export enum ApprovalDetailsType {
  queue = "queue",
  history = "history",
}
